import React from "react";
import Section from "./Section";
import CenteredColumns from "./CenteredColumns";
import "./FeaturesSection5.scss";

function FeaturesSection5(props) {
  const items = [
    {
      title: "Use our apps",
      subtitle:
        "Our suite of applications, toolkits and related white-label services offer practical solutions for organizations and creators to protect their data/IP from AI misappropriation and earn fair compensation for their registered/copyrighted work.",
      iconClass: "fas fa-rocket",
      iconColor: "primary",
    },
    {
      title: "Build your own apps",
      subtitle:
        "Our APIs and protocol integrate our blockchain-enabled data/IP management systems into your application to register/protect application data and license data/IP access to LLMs and AI companies.",
      iconClass: "fas fa-hammer",
      iconColor: "info",
    },
    {
      title: "Develop a compliant LLM",
      subtitle:
        "LLMs and GPT applications using PDS to manage data throughput in compliance with IP laws & regulations and generate revenue for all stakeholders.",
      iconClass: "fas fa-gavel",
      iconColor: "primary",
    },
  ];

  return (
    <Section
      color={props.color}
      size={props.size}
      backgroundImage={props.backgroundImage}
      backgroundImageOpacity={props.backgroundImageOpacity}
    >
      <div className="container">
        <CenteredColumns>
          {items.map((item, index) => (
            <div className="column has-text-centered" key={index}>
              <div className="FeaturesSection5__feature">
                <div
                  className={`FeaturesSection5__icon icon is-size-1 has-text-${item.iconColor}`}
                >
                  <i className={`${item.iconClass}`} />
                </div>
                <h1 className="title is-4 is-spaced">{item.title}</h1>
                <h2 className="subtitle is-6 has-text-grey-darker">
                  {item.subtitle}
                </h2>
              </div>
            </div>
          ))}
        </CenteredColumns>
      </div>
    </Section>
  );
}

export default FeaturesSection5;
